const PaginationControls = ({
  currentIndex,
  currentSlide,
  totalItems,
  handlePrevious,
  handleNext,
  setCurrentPage,
  itemsPerPage,
  itemsLength,
}) => {
  const indicators = [];
  for (let i = 0; i < totalItems; i++) {
    indicators.push(
      <div
        key={i}
        onClick={() => setCurrentPage(i)}
        className={`w-[5px] h-[5px] md:w-2 md:h-2 rounded-full cursor-pointer ${
          i === currentSlide
            ? "bg-grey-normal w-[6px] h-[6px] md:w-3 md:h-3"
            : "bg-grey-lighActive"
        }`}
      />
    );
  }

  return (
    <div className="w-full flex justify-between">
      {/* Previous Button */}
      <div
        onClick={handlePrevious}
        className={`p-[5px] ${
          currentIndex === 0
            ? "opacity-50 cursor-not-allowed pointer-events-none"
            : "cursor-pointer"
        }`}
      >
        <svg
          viewBox="0 0 8 12"
          className="fill-[#1C1B1F] hover:fill-slate-500 w-2 h-3 md:w-4 md:h-5"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M3.05375 6.00043L7.65375 1.40043L6.6 0.34668L0.946247 6.00043L6.6 11.6542L7.65375 10.6004L3.05375 6.00043Z" />
        </svg>
      </div>

      {/* Indicators */}
      <div className="flex justify-center items-center gap-1">{indicators}</div>

      {/* Next Button */}
      <div
        onClick={handleNext}
        className={`p-[5px] ${
          currentIndex + itemsPerPage >= itemsLength
            ? "opacity-50 cursor-not-allowed pointer-events-none"
            : "cursor-pointer"
        }`}
      >
        <svg
          viewBox="0 0 8 12"
          className="fill-[#1C1B1F] w-2 h-3 md:w-4 md:h-5"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4.94625 6.00043L0.346252 1.40043L1.4 0.34668L7.05375 6.00043L1.4 11.6542L0.346252 10.6004L4.94625 6.00043Z" />
        </svg>
      </div>
    </div>
  );
};

export default PaginationControls;
